<template>
  <li
    v-if="nativeStorageView?.supportsAudioDownloads"
    class="control-menu__unit"
  >
    <button
      v-if="nativeStorageView.audioDownloadState === 'noDownload'"
      class="control-menu__link"
      data-test-id="download-audio"
      @click="nativeStorageView.downloadAudio"
    >
      <span class="control-menu__icon iconfont idownload"></span>
      <span>Download Audio</span>
    </button>
    <button
      v-else-if="nativeStorageView.audioDownloadState === 'inProgress'"
      class="control-menu__link"
      data-test-id="downloading-audio"
      disabled
    >
      <span class="control-menu__icon iconfont idownload"></span>
      <span>Downloading Audio...</span>
    </button>
    <button
      v-else
      class="control-menu__link"
      data-test-id="delete-audio"
      @click="nativeStorageView.deleteAudioDownload"
    >
      <span class="control-menu__icon iconfont idelete"></span>
      <span>Remove Audio Download</span>
    </button>
  </li>
</template>

<script setup lang="ts">
import { BookNativeStorageView } from '@/models/book.native.storage.view'

defineProps<{
  nativeStorageView: BookNativeStorageView | null
}>()
</script>
